import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
  'pt-BR': {
    // Common
    app_name: 'TabKeeper',
    welcome_back: 'Bem-vindo de volta!',
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    close: 'Fechar',
    search: 'Buscar...',
    filter: 'Filtro:',
    all: 'Todos',
    new: 'Novo',
    
    // Auth
    sign_in: 'Entrar',
    sign_out: 'Sair',
    email: 'Email',
    password: 'Senha',
    continue_with_google: 'Continuar com Google',
    dont_have_account: "Não tem uma conta? Criar uma",
    already_have_account: 'Já tem uma conta? Entrar',
    create_account: 'Criar Conta',
    name: 'Nome',
    
    // Dashboard
    all_bookmarks: 'Todos os Favoritos',
    categories: 'Categorias',
    new_category: 'Nova Categoria',
    category_name: 'Nome da categoria...',
    
    // Bookmarks
    add_bookmark: 'Novo Favorito',
    edit_bookmark: 'Editar Favorito',
    bookmark_title: 'Título',
    bookmark_url: 'URL',
    bookmark_notes: 'Notas',
    bookmark_status: 'Status',
    bookmark_category: 'Categoria',
    no_category: 'Sem categoria',
    delete_bookmark_confirm: 'Tem certeza que deseja excluir este favorito?',
    
    // Status
    status_active: 'Ativo',
    status_completed: 'Concluído',
    status_in_progress: 'Em Andamento',
    status_paused: 'Pausado',
    status_archived: 'Arquivado',
    
    // Import/Export
    import: 'Importar',
    export: 'Exportar',
    import_bookmarks: 'Importar Favoritos',
    export_bookmarks: 'Exportar Favoritos',
    import_from_chrome: 'Importar do Chrome',
    select_file: 'Selecionar arquivo',
    import_preview: 'Pré-visualização',
    import_success: 'Favoritos importados com sucesso!',
    export_success: 'Favoritos exportados com sucesso!',
    
    // Settings
    settings: 'Configurações',
    chrome_extension: 'Extensão do Chrome',
    chrome_extension_desc: 'Baixe a extensão para salvar favoritos diretamente do navegador.',
    download_extension: 'Baixar Extensão (ZIP)',
    how_to_install: 'Como instalar:',
    install_step_1: 'Baixe o arquivo ZIP da extensão',
    install_step_2: 'Abra chrome://extensions no Chrome',
    install_step_3: 'Ative o "Modo do desenvolvedor"',
    install_step_4: 'Clique em "Carregar sem compactação"',
    install_step_5: 'Selecione a pasta da extensão extraída',
    api_tokens: 'Tokens de Acesso',
    api_tokens_desc: 'Crie tokens para usar na extensão do Chrome ou em integrações.',
    create_token: 'Criar Token',
    token_name: 'Nome do token',
    token_created: 'Novo token criado! Copie agora, ele não será exibido novamente.',
    copy: 'Copiar',
    no_tokens: 'Nenhum token criado ainda.',
    delete_token_confirm: 'Tem certeza que deseja excluir este token?',
    
    // Theme & Language
    theme: 'Tema',
    theme_light: 'Claro',
    theme_dark: 'Escuro',
    language: 'Idioma',
    
    // Tags
    tags: 'Tags',
    tag_name: 'Nome da tag...',
    tag_created: 'Tag criada!',
    tag_deleted: 'Tag excluída!',
    delete_tag_confirm: 'Excluir esta tag? Ela será removida de todos os favoritos.',
    no_tags: 'Nenhuma tag criada ainda.',
    manage_tags: 'Gerenciar Tags',
    
    // Categories
    manage_categories: 'Gerenciar Categorias',
    delete_category_confirm: 'Excluir esta categoria e todas as subcategorias?',
    
    // Actions
    open_tab: 'Abrir',
    open_all: 'Abrir todos',
    copy_url: 'Copiar URL',
    copied: 'Copiado!',
    
    // Messages
    bookmark_saved: 'Favorito salvo!',
    bookmark_deleted: 'Favorito excluído!',
    category_created: 'Categoria criada!',
    category_deleted: 'Categoria excluída!',
    token_deleted: 'Token excluído!',
    error_occurred: 'Ocorreu um erro',
    
    // Empty states
    no_bookmarks: 'Sem favoritos ainda',
    no_bookmarks_desc: 'Importe do Chrome ou crie seu primeiro favorito.',
    no_categories: 'Nenhuma categoria ainda.',
    no_categories_desc: 'Clique + para criar uma',
  },
  
  'en': {
    // Common
    app_name: 'TabKeeper',
    welcome_back: 'Welcome back!',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    search: 'Search...',
    filter: 'Filter:',
    all: 'All',
    new: 'New',
    
    // Auth
    sign_in: 'Sign In',
    sign_out: 'Sign Out',
    email: 'Email',
    password: 'Password',
    continue_with_google: 'Continue with Google',
    dont_have_account: "Don't have an account? Create one",
    already_have_account: 'Already have an account? Sign in',
    create_account: 'Create Account',
    name: 'Name',
    
    // Dashboard
    all_bookmarks: 'All Bookmarks',
    categories: 'Categories',
    new_category: 'New Category',
    category_name: 'Category name...',
    
    // Bookmarks
    add_bookmark: 'New Bookmark',
    edit_bookmark: 'Edit Bookmark',
    bookmark_title: 'Title',
    bookmark_url: 'URL',
    bookmark_notes: 'Notes',
    bookmark_status: 'Status',
    bookmark_category: 'Category',
    no_category: 'No category',
    delete_bookmark_confirm: 'Are you sure you want to delete this bookmark?',
    
    // Status
    status_active: 'Active',
    status_completed: 'Completed',
    status_in_progress: 'In Progress',
    status_paused: 'Paused',
    status_archived: 'Archived',
    
    // Import/Export
    import: 'Import',
    export: 'Export',
    import_bookmarks: 'Import Bookmarks',
    export_bookmarks: 'Export Bookmarks',
    import_from_chrome: 'Import from Chrome',
    select_file: 'Select file',
    import_preview: 'Preview',
    import_success: 'Bookmarks imported successfully!',
    export_success: 'Bookmarks exported successfully!',
    
    // Settings
    settings: 'Settings',
    chrome_extension: 'Chrome Extension',
    chrome_extension_desc: 'Download the extension to save bookmarks directly from your browser.',
    download_extension: 'Download Extension (ZIP)',
    how_to_install: 'How to install:',
    install_step_1: 'Download the extension ZIP file',
    install_step_2: 'Open chrome://extensions in Chrome',
    install_step_3: 'Enable "Developer mode"',
    install_step_4: 'Click "Load unpacked"',
    install_step_5: 'Select the extracted extension folder',
    api_tokens: 'Access Tokens',
    api_tokens_desc: 'Create tokens to use in the Chrome extension or integrations.',
    create_token: 'Create Token',
    token_name: 'Token name',
    token_created: 'New token created! Copy it now, it will not be shown again.',
    copy: 'Copy',
    no_tokens: 'No tokens created yet.',
    delete_token_confirm: 'Are you sure you want to delete this token?',
    
    // Theme & Language
    theme: 'Theme',
    theme_light: 'Light',
    theme_dark: 'Dark',
    language: 'Language',
    
    // Tags
    tags: 'Tags',
    tag_name: 'Tag name...',
    tag_created: 'Tag created!',
    tag_deleted: 'Tag deleted!',
    delete_tag_confirm: 'Delete this tag? It will be removed from all bookmarks.',
    no_tags: 'No tags created yet.',
    manage_tags: 'Manage Tags',
    
    // Categories
    manage_categories: 'Manage Categories',
    delete_category_confirm: 'Delete this category and all subcategories?',
    
    // Actions
    open_tab: 'Open',
    open_all: 'Open all',
    copy_url: 'Copy URL',
    copied: 'Copied!',
    
    // Messages
    bookmark_saved: 'Bookmark saved!',
    bookmark_deleted: 'Bookmark deleted!',
    category_created: 'Category created!',
    category_deleted: 'Category deleted!',
    token_deleted: 'Token deleted!',
    error_occurred: 'An error occurred',
    
    // Empty states
    no_bookmarks: 'No bookmarks yet',
    no_bookmarks_desc: 'Import from Chrome or create your first bookmark.',
    no_categories: 'No categories yet.',
    no_categories_desc: 'Click + to create one',
  },
  
  'es': {
    // Common
    app_name: 'TabKeeper',
    welcome_back: '¡Bienvenido de nuevo!',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    search: 'Buscar...',
    filter: 'Filtro:',
    all: 'Todos',
    new: 'Nuevo',
    
    // Auth
    sign_in: 'Iniciar Sesión',
    sign_out: 'Cerrar Sesión',
    email: 'Email',
    password: 'Contraseña',
    continue_with_google: 'Continuar con Google',
    dont_have_account: '¿No tienes cuenta? Crear una',
    already_have_account: '¿Ya tienes cuenta? Iniciar sesión',
    create_account: 'Crear Cuenta',
    name: 'Nombre',
    
    // Dashboard
    all_bookmarks: 'Todos los Favoritos',
    categories: 'Categorías',
    new_category: 'Nueva Categoría',
    category_name: 'Nombre de la categoría...',
    
    // Bookmarks
    add_bookmark: 'Nuevo Favorito',
    edit_bookmark: 'Editar Favorito',
    bookmark_title: 'Título',
    bookmark_url: 'URL',
    bookmark_notes: 'Notas',
    bookmark_status: 'Estado',
    bookmark_category: 'Categoría',
    no_category: 'Sin categoría',
    delete_bookmark_confirm: '¿Estás seguro de que quieres eliminar este favorito?',
    
    // Status
    status_active: 'Activo',
    status_completed: 'Completado',
    status_in_progress: 'En Progreso',
    status_paused: 'Pausado',
    status_archived: 'Archivado',
    
    // Import/Export
    import: 'Importar',
    export: 'Exportar',
    import_bookmarks: 'Importar Favoritos',
    export_bookmarks: 'Exportar Favoritos',
    import_from_chrome: 'Importar de Chrome',
    select_file: 'Seleccionar archivo',
    import_preview: 'Vista previa',
    import_success: '¡Favoritos importados con éxito!',
    export_success: '¡Favoritos exportados con éxito!',
    
    // Settings
    settings: 'Configuración',
    chrome_extension: 'Extensión de Chrome',
    chrome_extension_desc: 'Descarga la extensión para guardar favoritos directamente desde el navegador.',
    download_extension: 'Descargar Extensión (ZIP)',
    how_to_install: 'Cómo instalar:',
    install_step_1: 'Descarga el archivo ZIP de la extensión',
    install_step_2: 'Abre chrome://extensions en Chrome',
    install_step_3: 'Activa el "Modo de desarrollador"',
    install_step_4: 'Haz clic en "Cargar descomprimida"',
    install_step_5: 'Selecciona la carpeta de la extensión extraída',
    api_tokens: 'Tokens de Acceso',
    api_tokens_desc: 'Crea tokens para usar en la extensión de Chrome o integraciones.',
    create_token: 'Crear Token',
    token_name: 'Nombre del token',
    token_created: '¡Nuevo token creado! Cópialo ahora, no se mostrará de nuevo.',
    copy: 'Copiar',
    no_tokens: 'Ningún token creado todavía.',
    delete_token_confirm: '¿Estás seguro de que quieres eliminar este token?',
    
    // Theme & Language
    theme: 'Tema',
    theme_light: 'Claro',
    theme_dark: 'Oscuro',
    language: 'Idioma',
    
    // Tags
    tags: 'Etiquetas',
    tag_name: 'Nombre de la etiqueta...',
    tag_created: '¡Etiqueta creada!',
    tag_deleted: '¡Etiqueta eliminada!',
    delete_tag_confirm: '¿Eliminar esta etiqueta? Se eliminará de todos los favoritos.',
    no_tags: 'Ninguna etiqueta creada todavía.',
    manage_tags: 'Gestionar Etiquetas',
    
    // Categories
    manage_categories: 'Gestionar Categorías',
    delete_category_confirm: '¿Eliminar esta categoría y todas las subcategorías?',
    
    // Actions
    open_tab: 'Abrir',
    open_all: 'Abrir todos',
    copy_url: 'Copiar URL',
    copied: '¡Copiado!',
    
    // Messages
    bookmark_saved: '¡Favorito guardado!',
    bookmark_deleted: '¡Favorito eliminado!',
    category_created: '¡Categoría creada!',
    category_deleted: '¡Categoría eliminada!',
    token_deleted: '¡Token eliminado!',
    error_occurred: 'Ocurrió un error',
    
    // Empty states
    no_bookmarks: 'Sin favoritos todavía',
    no_bookmarks_desc: 'Importa de Chrome o crea tu primer favorito.',
    no_categories: 'Sin categorías todavía.',
    no_categories_desc: 'Haz clic en + para crear una',
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('tabkeeper-language');
    if (saved && translations[saved]) return saved;
    
    // Check browser language
    const browserLang = navigator.language;
    if (browserLang.startsWith('pt')) return 'pt-BR';
    if (browserLang.startsWith('es')) return 'es';
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('tabkeeper-language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
    languages: [
      { code: 'pt-BR', name: 'Português (Brasil)', flag: '🇧🇷' },
      { code: 'en', name: 'English', flag: '🇺🇸' },
      { code: 'es', name: 'Español', flag: '🇪🇸' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
